import { render, staticRenderFns } from "./messages-list.vue?vue&type=template&id=52fdb44e"
import script from "./messages-list.vue?vue&type=script&lang=js"
export * from "./messages-list.vue?vue&type=script&lang=js"
import style0 from "./messages-list.vue?vue&type=style&index=0&id=52fdb44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports